import axios from 'axios';
import { ReactNode, useEffect } from 'react';

import { useNotification } from 'hooks';
import { StatusCode } from 'enums';

interface Props {
  children: ReactNode;
}

export const InterceptorsProvider = ({ children }: Props) => {
  const sendNotification = useNotification();

  useEffect(() => {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status !== StatusCode.NotFound) {
          sendNotification(error.message, 'error');
        }

        return Promise.reject(error);
      },
    );
  }, [sendNotification]);

  return children;
};
